import React, { useState } from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  boxContent: {
    padding: '16px',
    // borderTop:`solid 1px ${theme.palette.primary.main}`,
    borderBottom: `solid 1.5px #edf1f2`,
    // marginBottom: '20px',
    display: 'flex',
    cursor: 'pointer',
  },
  textIcon: {
    marginLeft: '8px'
  }
}));

const FAQS = ({ question, handleGoQuestion }) => {
  const Icon = question.icon;
  const classes = useStyles();

  return (
    <Box
      key={question.id}
      onClick={() => handleGoQuestion()}
      className={classes.boxContent}
    >
      <Icon />
      <Typography className={classes.textIcon}>{question.type}</Typography>
    </Box>
    //   <Box key={question.id} className={classes.headerBox}>
    //     <Paper>
    //       <ListItem>
    // <ListItemText>{question.type}</ListItemText>
    //       </ListItem>
    //     </Paper>
    //   </Box>
  );
};

export default FAQS;
